/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
export type ArticleStateType = "available" | "deleted" | "draft" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type Main_viewer$ref: FragmentReference;
export type Main_viewer = {|
  +articles: ?{|
    +totalCount: ?number,
    +articles: ?$ReadOnlyArray<?{|
      +id: string,
      +title: ?string,
      +sectionName: ?string,
      +section: ?string,
      +availableAt: ?string,
      +state: ArticleStateType,
      +authorName: ?string,
    |}>,
  |},
  +$refType: Main_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "Main_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "page",
      "type": "Int!",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "search",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "states",
      "type": "[ArticleStateType]",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "articles",
      "name": "articlesPaginate",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page",
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "pageSize",
          "value": 12,
          "type": "Int"
        },
        {
          "kind": "Variable",
          "name": "plainSearch",
          "variableName": "search",
          "type": "String"
        },
        {
          "kind": "Variable",
          "name": "states",
          "variableName": "states",
          "type": "[ArticleStateType]"
        }
      ],
      "concreteType": "ArticlesPagination",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalCount",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "articles",
          "storageKey": null,
          "args": null,
          "concreteType": "Article",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "id",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "sectionName",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "section",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "availableAt",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "state",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "authorName",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '77ed57df397cad0564427fbb1b2849a1';
module.exports = node;



// WEBPACK FOOTER //
// src/components/main/__generated__/Main_viewer.graphql.js